export const MaxPreferredQueueSize = 20

export const CreateBookingSteps = Object.freeze({
  DetailsStep: 1,
  SelectEducatorsStep: 2,
})

export const CertChipLimits = {
  isMediumOrLower: 6,
  isLargeOrHigher: 8,
}

export const TruncationCert = {
  certId: 'certifications-overflow-indicator',
  typeName: '...',
}

/**
 * vuedraggable group names used to wire the select-educators drag interactions.
 * @property {string} availableEducators - source group for the bookable educator list
 * @property {string} preferredQueue - the reorderable preferred educator queue
 * @property {string} removeFromQueue - overlay target rendered on the available list while queue dragging
 */
export const SelectEducatorsDragGroup = Object.freeze({
  availableEducators: 'available-educators',
  preferredQueue: 'preferred-queue',
  removeFromQueue: 'remove-from-queue',
})

export const EducatorListStates = Object.freeze({
  Loading: 'loading',
  Empty: 'empty',
  Error: 'error',
  Exhausted: 'exhausted',
  List: 'list',
})
